<template>
  <div style="padding: 20px; overflow: scroll; height: 100%">
    <div>
      <h1>Organization users</h1>
      <el-table :data="orgUsers" border style="width: 100%">
        <el-table-column prop="id" label="Id" width="90"></el-table-column>
        <el-table-column prop="user.status" label="Status" width="90">
        </el-table-column>
        <el-table-column prop="user.email" label="Email" width="240"></el-table-column>
        <el-table-column prop="user.first_name" label="First name"></el-table-column>
        <el-table-column prop="user.last_name" label="Last name"></el-table-column>
        <el-table-column prop="role.slug" label="Roles"></el-table-column>
        <el-table-column prop="permissions" label="Permissions"></el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.user.id)">Edit</el-button>
            <el-popconfirm title="Are you sure you want to delete ?" confirmButtonText="Yes" cancelButtonText="No"
              @confirm="removeUser(scope.row.user.id)">
              <el-button size="mini" type="danger" plain slot="reference"><i class="fas fa-times"></i></el-button>
            </el-popconfirm>
            <!-- <el-button @click="disable(scope.row.id)">Disable</el-button> -->
            <!-- <el-button>Delete</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button @click.prevent="close" style="position: absolute; right: 10px; top: 10px" size="small" plain><i
        class="fas fa-xmark"></i></el-button>
    <h3 v-if="!form.id">User form</h3>
    <h3 v-if="form.id">
      Editing user: {{ form.id }}
      <el-button @click="form = {}" size="small">+ Add new user</el-button>
    </h3>
    <el-button @click="showForm = true" v-if="!showForm">Show form</el-button>
    <el-form ref="orgUsersForm" :model="form" :rules="validationRules" label-width="240px" v-if="showForm">
      <el-form-item label="Email" prop="email">
        <el-input v-model="form.email" placeholder="Email"></el-input>
      </el-form-item>
      <el-form-item label="First Name" prop="first_name">
        <el-input v-model="form.first_name" placeholder="First Name"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="last_name">
        <el-input v-model="form.last_name" placeholder="Last Name"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input v-model="form.password" type="password" show-password placeholder="Password"></el-input>
      </el-form-item>
      <!-- <el-form-item label="Last Name" prop="last_name">
        <el-input v-model="form.last_name" placeholder="Last Name"></el-input>
      </el-form-item> -->
      <el-form-item label="Admin role" prop="admin_role">
        <el-select v-model="form.role_id" placeholder="Admin Role" style="width: 100%">
          <el-option key="7" label="School admin" :value="7"></el-option>
          <el-option key="8" label="Council admin" :value="8"></el-option>
          <el-option key="9" label="Org admin" :value="9"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="Council schools(sub-orgs)" prop="sub_organizations">
        <OrgSelectionAdmin
          @return-selection="updateSubOrgs"
          :multiple="true"
          :collapseTags="false"
          :initialSelection="form.sub_orgs"
          style="width: 94%"
        />
      </el-form-item> -->
      <!-- <el-form-item label="Multi school" prop="proxied_organizations">
        <OrgSelectionAdmin
          @return-selection="updateMultiSchools"
          :multiple="true"
          :collapseTags="false"
          :initialSelection="form.multi_schools"
          style="width: 94%"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="onSubmit()"><i class="fa-solid fa-database"></i> Save</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import ApiService from "@/services/ApiService";
// import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "OrgUsersModal",
  components: {
    // OrgSelectionAdmin,
  },
  data() {
    return {
      form: {
        sub_orgs: [],
        multi_schools: [],
      },
      orgUsers: [],
      validationRules: {},
      showForm: false,
      id: null,
    };
  },
  computed: {},
  props: {
    organization_id: {
      type: Number,
      required: true,
    },
    org_type: {
      type: String,
      required: true,
    },
  },
  methods: {
    getOrgUsers(orgId) {
      ApiService.sadminApi.getOrgUsers(orgId).then((resp) => {
        this.orgUsers = resp.data;
      });
    },
    closeModal() {
      this.close();
    },
    onSubmit() {
      this.$refs["orgUsersForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          ...this.form,
          organization_id: this.organization_id,
        };
        // if (this.id != 0) {
        //   payload.id = this.id;
        // }

        ApiService.sadminApi
          .postOrgUsers(this.organization_id, payload)
          .then((resp) => {
            this.$notify.info({
              title: "Saved",
              message: "Good things just happened!",
            });
            this.$emit("close");
          });
      });
    },
    edit(userId) {
      const match = { ...this.orgUsers.find((itm) => (itm.user.id = userId)) };
      if (match) {
        this.form = {
          id: userId,
          first_name: match.user.first_name,
          last_name: match.user.last_name,
          email: match.user.email,
          role_id: match.role_id,
          user_role_id: match.id
        };
      }
      this.showForm = true;
    },
    removeUser(userId) {
      ApiService.sadminApi.removeUser(userId).then((resp) => {
        this.$notify.info({
          title: "Deleted",
          message: "Good things just happened!",
        });
      });
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.getOrgUsers(this.organization_id);
  },
});
</script>
<style scoped>
.longInput {
  min-width: 300px;
}

#statusResponseTable {
  background: white;
  padding: 3px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border: 1px solid #bbb;
  margin: auto;
  border-radius: 10px;
}

#statusResponseTable td {
  padding: 2px;
  min-width: 200px;
}

#statusResponseTable tr td:nth-child(1) {
  font-weight: bold;
}

table#statusResponseTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}

#previewTable {
  border-collapse: collapse;
}

#previewTable thead {
  position: sticky;
  /* make the table heads sticky */
  top: 0px;
  /* table head will be placed from the top of the table and sticks to it */
  box-shadow: 0px 1px 2px #ccc;
}

#previewTable thead th {
  padding: 0px 5px;
  /* border-right: 1px solid #bbb; */
}

hr {
  opacity: 0.5;
}

label {
  font-weight: bold;
  /* min-width: 160px; */
  display: inline-block;
  line-height: 40px;
}

span.inlineButton {
  padding-left: 15px;
  display: inline-block;
}

th.headSmallCol {
  font-size: 8px;
  background: #f9f9f9;
  padding: 5px 0;
  box-shadow: 0px 1px 2px #ccc;
}

th.headSmallCol:nth-child(2n + 2) {
  color: orange;
  background: #f3f3f3;
}

table#previewTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}

td.tableCol {
  font-size: 9px;
  border: solid 1px #e6e6e6;
  border-left: 0;
  border-right: 0;
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 5px 0px;
}

td.tableCol:nth-child(2n + 2) {
  /* background: #fff8f2; */
}

.selectAllBtn {
  float: left;
  margin-top: 6px;
  margin-right: 5px;
}
</style>
